module.exports = __webpack_public_path__ + "static/media/schedule.4bce8a99.svg";